import { useState, useEffect } from "react";
import { useStudioErstellen } from "../../store/studioErstellenStore";

import classes from "./StudioDescription.module.css";
import ErrorMessage from "./ErrorMessage";

export const FifthStep = ({ validate }) => {
    const { studioData, updateStudioData } = useStudioErstellen();
    const [text, setText] = useState(studioData.description || '');
    const [errors, setErrors] = useState({
      title: "",
    });

    const MAX_LENGTH = 1500;
    
    const handleValidation = () => {
      if (text.trim() === "") {
        setErrors({ title: "Beschreibung muss ausgefüllt werden" });
        return false;
      }
      
      // Check if text contains only numbers
      if (/^\d+$/.test(text.trim())) {
        setErrors({ title: "Beschreibung darf nicht nur aus Zahlen bestehen" });
        return false;
      }
      
      // Count letters in the text
      const letterCount = (text.match(/[a-zA-ZäöüÄÖÜß]/g) || []).length;
      if (letterCount < 8) {
        setErrors({ title: "Beschreibung muss mindestens 8 Buchstaben enthalten" });
        return false;
      }
      
      if (text.length < 10) {
        setErrors({ title: "Beschreibung muss mindestens 10 Zeichen haben" });
        return false;
      }

      if (text.length > MAX_LENGTH) {
        setErrors({ title: `Beschreibung darf maximal ${MAX_LENGTH} Zeichen haben` });
        return false;
      }
  
      return true;
    };
  
    const handleInputChange = (event) => {
      const inputValue = event.target.value;
      setText(inputValue);
      updateStudioData('description', inputValue);

      if (inputValue.length > MAX_LENGTH) {
        setErrors({ title: `Beschreibung darf maximal ${MAX_LENGTH} Zeichen haben` });
      } else {
        setErrors({ title: "" });
      }
    };
  
    useEffect(() => {
      validate.current = handleValidation;
    }, [validate, text]);

  return (
    <div className={classes.mainContainer}>
        <h2 className={`${classes.title} titleSemibold`}>Erstelle eine Beschreibung für dein Studio.</h2>
        <div className={classes.textContainer}>
            <span className="slimRegularLarge">Beschreibe dein Studio so detailliert und klar wie möglich,</span>
            <span className="slimRegularLarge">damit Kunden alle notwendigen Informationen haben.</span>
        </div>
        <div className={classes.inputContainer}>
            <textarea
                type="text"
                className={`${classes.input} ${text.length > MAX_LENGTH ? classes.inputError : ""} slimRegularLargeText`}
                placeholder="Erstelle eine Beschreibung..."
                value={text}
                onChange={handleInputChange}
            />
            <div className={`${classes.textLength} slimRegularMiniText`}>
                {text.length}/1500
                {errors.title && <ErrorMessage>{errors.title}</ErrorMessage>}
            </div>
        </div>
    </div>
  );
};

export default FifthStep;